import { Dialog } from "@headlessui/react";
import clx from "classnames";
import { useContext } from "react";
import { AppLayoutContext } from "src/context/AppLayoutContext";
import CloseButton from "../components/CloseButton";
import Locale from "./core/Locale";
import OverlayContainer from "./OverlayContainer";
import Spinner from "./Spinner";

const WIDTHS = {
  md: "w-2/3 md:w-1/3",
  lg: "w-full md:w-1/2",
  xl: "w-full md:w-2/3",
  full: "w-full",
};

export default function AppModal({
  show = false,
  size = "md",
  scrollable = false,
  closeable = true,
  static: isStatic = false,
  onClose = () => {},
  title,
  body,
  footer,
  loading = false,
  bodyClassName = "",
}) {
  const { isMobile } = useContext(AppLayoutContext);

  return (
    <OverlayContainer show={show}>
      <Dialog as="div" open={show} className="relative z-10" onClose={() => (isStatic ? null : onClose())}>
        {/* Backdrop */}
        <div className="fixed inset-0 bg-gray-700 bg-opacity-30 transition-opacity" />
        <div className="fixed inset-0 z-10 flex justify-center px-0 pb-16 md:py-16 md:items-center">
          <Dialog.Panel
            className={`relative ${
              isMobile ? "w-full" : WIDTHS[size]
            } max-h-full flex flex-col transform transition-all  bg-card rounded-md shadow-none md:shadow-sm`}
          >
            <div className="flex items-center justify-between h-16 flex-shrink-0 px-4 border-b">
              <Dialog.Title as="div" className="card-title flex-shrink-0">
                {typeof title === "string" ? <Locale code={title ?? "-"} /> : title}
              </Dialog.Title>
              {loading ? <Spinner className="w-6 h-6 text-muted-fg" /> : closeable ? <CloseButton onClick={onClose} /> : <></>}
            </div>
            <div className={clx("flex-grow", { "p-4": !bodyClassName }, { "overflow-y-auto": isMobile ? true : scrollable })}>{body}</div>
            {footer && <div className="p-4 flex items-center border-t">{footer}</div>}
          </Dialog.Panel>
        </div>
      </Dialog>
    </OverlayContainer>
  );
}
